// extracted by mini-css-extract-plugin
export default {"varFontSize100":"0.75rem","title":"title--mp-ZskcI","awards-container":"awards-container--mp-gwXl1","awardsContainer":"awards-container--mp-gwXl1"};